import { useMediaQuery } from '@mui/material';
import { useFromMobile } from './useFromMobile';

// True for small screens as well as the mobile app handoff webview, so layout
// follows the actual viewport instead of only the `fromMobile` session flag.
export const useMobileView = (): boolean => {
  const mediumViewport = useMediaQuery('(max-width:768px)');
  const fromMobile = useFromMobile();

  return mediumViewport || fromMobile;
};
